import { Box, ContentBlock } from 'braid-design-system';

import * as styles from './PanelVideo.css';

export const PanelVideo = () => (
  <ContentBlock width="small" align="left">
    <Box
      className={styles.videoWrapper}
      borderRadius={['none', 'large']}
      display="flex"
      justifyContent="center"
      paddingY="medium"
    >
      <iframe
        className={styles.video}
        src="https://players.brightcove.net/6040621522001/qx6UKDb3d_default/index.html?videoId=6363724113112"
        allowFullScreen
      />
    </Box>
  </ContentBlock>
);
